import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Landing from './landing_page.js';
import Links from './links_page.js';
import Music from './music_page.js';
import Juugs from './juug_page.js';
import ArtistUpload from './upload_page.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} /> 
        <Route path='/link' element={<Links/>}/>
        <Route path='/music/:password' element={<Music/>}/>
        <Route path='/juug' element={<Juugs/>}/>
        <Route path='/uploadv1' element={<ArtistUpload/>}/>
      </Routes>
    </Router>
  );
}

export default App;
